<template>
    <div class="switch-wrapper tw-flex tw-flex-col tw-flex-1 tw-relative" :class="orientation">
        <template v-if="orientation === 'vertical'">
            <div class="switch-label-wrapper tw-flex tw-items-center tw-w-full">
                <i v-if="icon" class="tw-text-sm tw-mb-2 tw-mr-2" :class="icon"></i>
                <label class="tw-font-normal" v-text="label" v-if="label"></label>
            </div>
            <div class="switch-wrapper form-input-wrapper tw-flex tw-relative">
                <div class="switch tw-cursor-pointer" :class="{'active secondary-c-bg': value === true}" @click="toggle"></div>
            </div>
        </template>
        <template v-else>
            <div class="tw-flex tw-items-center tw-w-full">
                <div class="form-input-wrapper tw-flex tw-relative">
                    <div class="switch tw-cursor-pointer" :class="{'active secondary-c-bg': value === true}" @click="toggle"></div>
                </div>
                <label class="tw-mb-0 tw-ml-4 tw-flex-1 tw-font-normal" v-text="label" v-if="label"></label>
            </div>
        </template>

        <p class="helper" v-if="helper" v-text="helper"></p>
    </div>
</template>

<script>
    export default {
        name: 'FormSwitch',

        props: {
            value: {
                default: false,
            },
            label: {
                default: false,
            },
            helper: {
                default: false,
            },
            icon: {
                default: false,
            },
            orientation: {
                default: 'vertical',
            },
        },

        methods: {
            toggle() {
                this.$emit('input', !this.value);
                this.$emit('toggle', !this.value);
            },

            validateType() {
                if (typeof this.value === 'string') {
                    if (this.value === '1' || this.value === 'true') {
                        this.$emit('input', true);
                    } else {
                        this.$emit('input', false);
                    }
                } else if (typeof this.value === 'number') {
                    if (this.value === 1) {
                        this.$emit('input', true);
                    } else {
                        this.$emit('input', false);
                    }
                }
            },
        },

        mounted() {
            this.validateType();
        },

        watch: {
            value() {
                this.validateType();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .switch {
        height: 21px !important;
        width: 55px !important;

        &:before {
            @apply tw-bg-white tw-absolute tw-rounded-full;
            transition: left 0.2s, transform 0.2s;
            content: "";
            height: 25px;
            width: 25px;
            border-radius: 100%;
            top: -3px;
            left: -1px;
            box-shadow: 0 3px 6px rgba(0,0,0,.16);
        }

        &.active {
            &:before {
                left: 59%;
            }
        }

        &:active {
            &:before {
                transform: scaleY(0.95);
            }
        }
    }

    .horizontal-switch-wrapper {
        @apply tw-flex tw-justify-between tw-items-center tw-w-full;

        .switch-desc {
            @apply tw-flex tw-flex-col tw-mr-4;

            label {
                @apply tw-mb-0 tw-mr-4 tw-mb-1;
            }

            span {
                @apply tw-text-sm;
            }
        }

        .switch-wrapper {
            @apply tw-flex-none;
        }
    }
</style>